<template>
  <v-dialog v-model="$store.state.customDialogTrigger">
    <v-card class="dialog" style="padding: 25px; margin:0">
      <h3 class="title-go-left">{{ this.$store.state.currentDialog.name }}</h3>
      <div>
        {{ this.$store.state.currentDialog.address.street }}
        <br>
        {{ this.$store.state.currentDialog.address.postal }}
      </div>
      <div style="margin-top:25px">
        <v-btn block color="primary" class="mb-2 text-left" @click="setActiveCustomer($store.state.currentDialog);">Checka in &amp; ut</v-btn>
        <a :href="directionsUrl" class="btn btn--block mb2 text-left" target="_blank">Vägbeskrivning</a>
      </div>
      <div style="margin-top:25px">
        {{ this.$store.state.currentDialog.address.comment }}
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    data(){
      return{

      }
    },
    methods:{
      getDirections(custLat, custLng, custName){
        if ((navigator.platform.indexOf("iPhone") != -1) ||
            (navigator.platform.indexOf("iPod") != -1) ||
            (navigator.platform.indexOf("iPad") != -1)) {
          //window.open("maps://maps.google.com/maps/dir/?daddr=" + custLat + "," + custLng + "&amp;ll=");
          window.open("maps://www.google.com/maps/dir/?api=1&origin=current+location&destination=" + custName + "&travelmode=driving");
        }else{
          //https://maps.google.com/maps/dir/?daddr=" + custLat + "," + custLng + "&amp;ll=
          window.open("https://www.google.com/maps/dir/?api=1&origin=current+location&destination=" + custName + "&travelmode=driving");
        }
      },
      setActiveCustomer(customer){
        this.$store.state.currentSignatories = customer.signatories;
        this.$store.state.activeCustomer.custID = customer.customer_id;
        this.$store.state.activeCustomer.name = customer.name;
        this.$store.state.activeCustomer.address = customer.address;

        this.$store.state.customDialogTrigger = false;

        this.$router.push('CheckInOut');
      },
    },
    computed:{
      dialogTrigger: function dialogTrigger(){
        return this.$store.state.customDialogTrigger;
      },
      directionsUrl() {
        let custName = this.$store.state.currentDialog.name;
        let lng = this.$store.state.currentDialog.address.longitude;
        let lat = this.$store.state.currentDialog.address.latitude;
        if ((navigator.platform.indexOf("iPhone") != -1) ||
            (navigator.platform.indexOf("iPod") != -1) ||
            (navigator.platform.indexOf("iPad") != -1)) {
          return `http://maps.apple.com/?q=${lat},${lng}&dirflg=d`;
        } else {
          return `https://www.google.com/maps/dir/?api=1&origin=current+location&destination=${lat},${lng}&travelmode=driving`;
        }
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Custom_Dialog.vue